import React from 'react';
import './App.css';
import Header from './com/Header'
import SignupInfo from './com/SignupInfo'
import Home from './com/Home'
import { BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import ReactGA from 'react-ga';
// ReactGA.initialize('UA-138580990-1',{
//   cookie_flags:'max-age=7200;secure;samesite=strict',
//   cookieFlags:'max-age=7200;secure;samesite=strict',
// });
// ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  return (
    <div>
      <Header/>
      <Router basename={'/auth2'}>
        <Switch>
          <Route  component={Home} path="/"  exact />
          <Route  component={SignupInfo} path="/signup" exact />
        </Switch>
      </Router>
    </div>
     
  );
}

export default App;
